/**
 * CloudMap Clustering
 * Marker clustering functionality
 */

/**
 * Setup marker clusterer
 */
export function setupClusterer(map, markers, config, existingClusterer) {
    if (existingClusterer) {
        existingClusterer.clearMarkers();
    }

    if (!window.markerClusterer || markers.length === 0) {
        return null;
    }

    const {MarkerClusterer} = markerClusterer;

    return new MarkerClusterer({
        map: map,
        markers: markers,
        algorithmOptions: {
            maxZoom: 15,
            radius: config.defaults?.clusterRadius || 50,
        },
        renderer: {
            render: ({count, position}) => {
                const sizeClass = count > 50 ? 'xlarge' : count > 20 ? 'large' : '';

                // Create cluster marker
                if (google.maps.marker?.AdvancedMarkerElement && config.googleMaps?.mapId) {
                    const el = document.createElement('div');
                    el.className = `cloudmap-cluster ${sizeClass}`;
                    el.textContent = count;

                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: el,
                    });
                }

                return new google.maps.Marker({
                    position,
                    label: {
                        text: String(count),
                        color: '#ffffff',
                        fontWeight: 'bold',
                    },
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        fillColor: '#666666',
                        fillOpacity: 1,
                        strokeColor: '#ffffff',
                        strokeWeight: 3,
                        scale: count > 50 ? 25 : count > 20 ? 20 : 15,
                    },
                });
            },
        },
    });
}
